import script from "./AppointementNew.vue?vue&type=script&setup=true&lang=js"
export * from "./AppointementNew.vue?vue&type=script&setup=true&lang=js"

import "./AppointementNew.vue?vue&type=style&index=0&id=6322519a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6322519a"]])

export default __exports__